<template>
 <tbl-prop-comp-combined class="mt-2" :project="project" :decorateNumerals="true"/>
</template>

<script>
import TblPropCompCombined from '@/components/modules/projects/ui/tblPropCompCombined'
export default {
  name: 'projectCPCombinedCard',
  props: ['project', 'activeTab'],
  components: { TblPropCompCombined }
}
</script>

<style scoped>

</style>
